import { BranchIfEvenInstruction } from "./instructions/BranchIfEvenInstruction";
import { FaceDownInstruction } from "./instructions/FaceDownInstruction";
import { FaceLeftInstruction } from "./instructions/FaceLeftInstruction";
import { FaceRightInstruction } from "./instructions/FaceRightInstruction";
import { FaceThenRotateInstruction } from "./instructions/FaceThenRotateInstruction";
import { FaceUpInstruction } from "./instructions/FaceUpInstruction";
import { FluxJumpInstruction } from "./instructions/FluxJumpInstruction";
import { JumpInstruction } from "./instructions/JumpInstruction";
import { ManaFocusInstruction } from "./instructions/ManaFocusInstruction";
import { ManaInstruction } from "./instructions/ManaInstruction";
import { NewLineInstruction } from "./instructions/NewLineInstruction";
import { ReferenceInstruction } from "./instructions/ReferenceInstruction";
import { SensorInputInstruction } from "./instructions/SensorInputInstruction";
import { TransposeInstruction } from "./instructions/TransposeInstruction";

export const instructions = [
  new FaceUpInstruction(),
  new FaceDownInstruction(),
  new FaceLeftInstruction(),
  new FaceRightInstruction(),
  new ManaFocusInstruction(),
  new ManaInstruction(),
  new NewLineInstruction(),
  new JumpInstruction(),
  new TransposeInstruction(),
  new BranchIfEvenInstruction(),
  new ReferenceInstruction("test"),
  new ReferenceInstruction("test-other"),
  new FaceThenRotateInstruction("down"),
  new FluxJumpInstruction(),
  new SensorInputInstruction(),
] as const;

export const instructionsMap = Object.fromEntries(
  instructions.map((instruction) => [instruction.type, instruction])
) as {
  [I in (typeof instructions)[number] as I["type"]]: I;
};

export type InstructionType = keyof typeof instructionsMap;
